export default __webpack_public_path__ + "static/media/fireGif.fc4816fa.gif";